import React from 'react';
import AirportScene from '../components/AirportScene';
const Home = () => {
  
  return (
    <div className="h-screen w-screen overflow-hidden">
      <AirportScene />
    </div>
  );
};

export default Home;
